<article class="product-card" [class.product-card--list-item]="listItem()">
  <figure class="product-card__figure" [class.is--loading]="!product" [class.is--sold-out]="!product?.availableForSale">
    @defer (on idle; hydrate on idle) {
      <app-product-image-slider
        [showVideos]="false"
        [product]="product"
        [hasLink]="true"
        [showVariantImages]="true"
        [collectionHandle]="collectionHandle"
        [sizes]="sizes"
        [showPagination]="false"
        [initOnInteraction]="true"
        [showQuickAdd]="compact()"
        [showLabels]="!compact()"
      ></app-product-image-slider>
    }
  </figure>

  <main class="mt-2 product-card__content" [class.is--sold-out]="!product?.availableForSale" [class.d-block]="compact()">
    <div class="product-card__content__text">
      <a
        class="link link--dark"
        [routerLink]="collectionHandle ? ['/', 'collections', collectionHandle, product?.handle] : ['/', 'products', product?.handle]"
      >
        <span class="mb-0 product-card__content__title h6 fw-normal hyphens">
          {{ product?.title || productPreview?.title }}
        </span>
      </a>
      @if (!compact()) {
        <span class="type-body-sm">{{ product?.productType }}</span>
      }
      <!-- <span class="type-body-sm" *ngIf="product?.collections">
    {{ collectionsAsText(product?.collections) }}
  </span> -->
    </div>

    <!-- <strong *ngIf="product?.compareAtPriceRange?.maxVariantPrice.amount > 0"><del>{{ product?.compareAtPriceRange?.maxVariantPrice.amount | currency: 'EUR'}}</del></strong> -->

    @if (product?.priceRange?.minVariantPrice) {
      <div class="product-card__content__meta type-body-md">
        <app-product-price [product]="product" [showLabel]="!compact()"></app-product-price>
      </div>
    }
  </main>
  <ul class="swatch-list swatch-list--sm mt-2-5">
    @for (colorLabel of getColorOption()?.values; track colorLabel; let i = $index) {
      <li class="swatch-list__item">
        <a
          class="swatch"
          [style.--swatch-color]="getColorForOption(colorLabel)"
          [class.is--white]="['white', '#fff', '#ffffff'].includes(getColorForOption(colorLabel) || '')"
          [routerLink]="collectionHandle ? ['/', 'collections', collectionHandle, product?.handle] : ['/', 'products', product?.handle]"
          [queryParams]="{ Color: colorLabel }"
        ></a>
      </li>
    }
  </ul>
</article>
